const resumeData = {
  simple: {
  common: {
    name: "Kiran Dev",
    title: "Full Stack Web Developer",

    summary:
      "Results-driven Full Stack Developer with 4+ years of experience designing, developing, and deploying scalable web applications using React, Django, and modern JavaScript frameworks. ",

    contact: {
      email: "frce75@gmail.com",
      phone: "+91 6844xxxxxx",
      linkedin: "linkedin.com/in/devad",
      github: "github.com/devad",
    },

    skills: [
      "JavaScript (ES6+)",
      "React.js",
      "Django",
      "Node.js",
      "Express.js",
      "MySQL",
      "MongoDB",
      "HTML5",
      "CSS3",
      "Tailwind CSS",
      "Bootstrap",
    ],
  },

  experience: [
    {
      role: "Senior Frontend Developer",
      company: "ABC Technologies",
      duration: "Jan 2022 – Present",
      desc:
        "Led development of enterprise-scale React applications serving 50K+ monthly users. Improved page load speed by 35% through code splitting and lazy loading. Collaborated with UX teams to redesign core dashboards, increasing user engagement by 28%. Mentored 3 junior developers and enforced best practices for reusable component architecture.",
    },
    {
      role: "Frontend Developer",
      company: "XYZ Solutions",
      duration: "Jun 2020 – Dec 2021",
      desc:
        "Built responsive and cross-browser compatible web interfaces using React and modern CSS. Reduced UI defects by 40% by introducing component testing with Jest. Integrated REST APIs and improved data fetching efficiency. Worked closely with backend teams in an agile sprint environment.",
    },
    {
      role: "Junior Web Developer",
      company: "Innovatech Systems",
      duration: "Jan 2019 – May 2020",
      desc:
        "Developed reusable UI components and assisted in building internal business tools. Implemented form validations and improved accessibility compliance. Participated in code reviews and contributed to performance optimization initiatives.",
    },
  ],

  projects: [
    {
      title: "Enterprise E-Commerce Platform",
      desc:
        "Designed and developed a scalable full-stack e-commerce application using React, Django REST Framework, and MySQL. Implemented secure authentication, product search, cart management, and Stripe payment integration. Optimized performance to handle high concurrent traffic.",
    },
    {
      title: "Real-Time Task Management System",
      desc:
        "Built a collaborative productivity platform with drag-and-drop Kanban boards using React and Firebase. Implemented real-time updates, role-based access control, and notification system to improve team workflow efficiency.",
    },
    {
      title: "Portfolio Website",
      desc:
        "Developed a fully responsive personal portfolio showcasing projects and technical skills. Implemented modern UI animations, SEO optimization, and performance tuning for fast load times.",
    },
  ],

  education: [
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "XYZ University",
      year: "2016 – 2020",
    },
    {
      degree: "Intermediate (MPC)",
      institution: "Sri Chaitanya Junior College",
      year: "2014 – 2016",
    },
  ],

  certifications: [
    { name: "AWS Certified Cloud Practitioner" },
    { name: "Meta Front-End Developer Professional Certificate" },
    { name: "Google Associate Cloud Engineer (Training)" },
    { name: "Responsive Web Design Certification – freeCodeCamp" },
    { name: "JavaScript Algorithms and Data Structures – freeCodeCamp" },
  ],
},
yellowbasic: {
  common: {
    name: "Kiran Dev",
    title: "Full Stack Web Developer",

    summary:
      "Results-driven Full Stack Developer with 4+ years of experience designing, developing, and deploying scalable web applications using React, Django, and modern JavaScript frameworks. ",

    contact: {
      email: "frce75@gmail.com",
      phone: "+91 6844xxxxxx",
      linkedin: "linkedin.com/in/devad",
      github: "github.com/devad",
    },

    skills: [
      "JavaScript (ES6+)",
      "React.js",
      "Django",
      "Node.js",
      "Express.js",
      "MySQL",
      "MongoDB",
      "HTML5",
      "CSS3",
      "Tailwind CSS",
    ],
  },
  experience: [
    {
      role: "Senior Frontend Developer",
      company: "ABC Technologies",
      duration: "Jan 2022 – Present",
      desc:
        "Led development of enterprise-scale React applications serving 50K+ monthly users. Improved page load speed by 35% through code splitting and lazy loading. Collaborated with UX teams to redesign core dashboards, increasing user engagement by 28%. Mentored 3 junior developers and enforced best practices for reusable component architecture.",
    },
    {
      role: "Frontend Developer",
      company: "XYZ Solutions",
      duration: "Jun 2020 – Dec 2021",
      desc:
        "Built responsive and cross-browser compatible web interfaces using React and modern CSS. Reduced UI defects by 40% by introducing component testing with Jest. Integrated REST APIs and improved data fetching efficiency. Worked closely with backend teams in an agile sprint environment.",
    },
    {
      role: "Junior Web Developer",
      company: "Innovatech Systems",
      duration: "Jan 2019 – May 2020",
      desc:
        "Developed reusable UI components and assisted in building internal business tools. Implemented form validations and improved accessibility compliance. Participated in code reviews and contributed to performance optimization initiatives.",
    },
  ],

  projects: [
    {
      title: "Enterprise E-Commerce Platform",
      desc:
        "Designed and developed a scalable full-stack e-commerce application using React, Django REST Framework, and MySQL. Implemented secure authentication, product search, cart management, and Stripe payment integration. Optimized performance to handle high concurrent traffic.",
    },
    {
      title: "Real-Time Task Management System",
      desc:
        "Built a collaborative productivity platform with drag-and-drop Kanban boards using React and Firebase. Implemented real-time updates, role-based access control, and notification system to improve team workflow efficiency.",
    },
    {
      title: "Portfolio Website",
      desc:
        "Developed a fully responsive personal portfolio showcasing projects and technical skills. Implemented modern UI animations, SEO optimization, and performance tuning for fast load times.",
    },
  ],

  education: [
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "XYZ University",
      year: "2016 – 2020",
    },
    {
      degree: "Intermediate (MPC)",
      institution: "Sri Chaitanya Junior College",
      year: "2014 – 2016",
    },
    {
      degree: "10th standard",
      institution: "Sri Chaitanya School",
      year: "2013 – 2014",
    },
  ],

  certifications: [
    { name: "AWS Certified Cloud Practitioner" },
    { name: "Meta Front-End Developer Professional Certificate" },
    { name: "Google Associate Cloud Engineer (Training)" },
    { name: "Responsive Web Design Certification – freeCodeCamp" },
    { name: "JavaScript Algorithms and Data Structures – freeCodeCamp" },
  ],
},
twosidedsimple: {
  common: {
    name: "Kiran Dev",
    title: "Full Stack Web Developer",

    summary:
      "Results-driven Full Stack Developer with 4+ years of experience designing, developing, and deploying scalable web applications using React, Django, and modern JavaScript frameworks. ",

    contact: {
      email: "frce75@gmail.com",
      phone: "+91 6844xxxxxx",
      linkedin: "linkedin.com/in/devad",
      github: "github.com/devad",
    },

    skills: [
      "JavaScript (ES6+)",
      "React.js",
      "Django",
      "Node.js",
      "Express.js",
      "MySQL",
      "MongoDB",
      "HTML5",
      "CSS3",
      "Tailwind CSS",
    ],
  },

  experience: [
    {
      role: "Senior Frontend Developer",
      company: "ABC Technologies",
      duration: "Jan 2022 – Present",
      desc:
        "Led development of enterprise-scale React applications serving 50K+ monthly users. Improved page load speed by 35% through code splitting and lazy loading. Collaborated with UX teams to redesign core dashboards, increasing user engagement by 28%. Mentored 3 junior developers and enforced best practices for reusable component architecture.",
    },
    {
      role: "Frontend Developer",
      company: "XYZ Solutions",
      duration: "Jun 2020 – Dec 2021",
      desc:
        "Built responsive and cross-browser compatible web interfaces using React and modern CSS. Reduced UI defects by 40% by introducing component testing with Jest. Integrated REST APIs and improved data fetching efficiency. Worked closely with backend teams in an agile sprint environment.",
    },
    {
      role: "Junior Web Developer",
      company: "Innovatech Systems",
      duration: "Jan 2019 – May 2020",
      desc:
        "Developed reusable UI components and assisted in building internal business tools. Implemented form validations and improved accessibility compliance. Participated in code reviews and contributed to performance optimization initiatives.",
    },
  ],

  projects: [
    {
      title: "Enterprise E-Commerce Platform",
      desc:
        "Designed and developed a scalable full-stack e-commerce application using React, Django REST Framework, and MySQL. Implemented secure authentication, product search, cart management, and Stripe payment integration. Optimized performance to handle high concurrent traffic.",
    },
    {
      title: "Real-Time Task Management System",
      desc:
        "Built a collaborative productivity platform with drag-and-drop Kanban boards using React and Firebase. Implemented real-time updates, role-based access control, and notification system to improve team workflow efficiency.",
    },
    {
      title: "Portfolio Website",
      desc:
        "Developed a fully responsive personal portfolio showcasing projects and technical skills. Implemented modern UI animations, SEO optimization, and performance tuning for fast load times.",
    },
  ],

  education: [
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "XYZ University",
      year: "2016 – 2020",
    },
    {
      degree: "Intermediate (MPC)",
      institution: "Sri Chaitanya Junior College",
      year: "2014 – 2016",
    },
    {
      degree: "10th standard",
      institution: "Sri Chaitanya School",
      year: "2013 – 2014",
    },
  ],

  certifications: [
    { name: "AWS Certified Cloud Practitioner" },
    { name: "Meta Front-End Developer Professional Certificate" },
    { name: "Google Associate Cloud Engineer (Training)" },
    { name: "Responsive Web Design Certification – freeCodeCamp" },
    { name: "JavaScript Algorithms and Data Structures – freeCodeCamp" },
  ],
},
border_highlight: {
  common: {
    name: "Kiran Dev",
    title: "Full Stack Web Developer",

    summary:
      "Results-driven Full Stack Developer with 4+ years of experience designing, developing, and deploying scalable web applications using React, Django, and modern JavaScript frameworks. ",

    contact: {
      email: "frce75@gmail.com",
      phone: "+91 6844xxxxxx",
      linkedin: "linkedin.com/in/devad",
      github: "github.com/devad",
    },

    skills: [
      "JavaScript (ES6+)",
      "React.js",
      "Django",
      "Express.js",
      "MySQL",
      "HTML5",
      "CSS3",
      "Tailwind CSS",
      "Bootstrap",
    ],
  },

  experience: [
    {
      role: "Senior Frontend Developer",
      company: "ABC Technologies",
      duration: "Jan 2022 – Present",
      desc:
        "Led development of enterprise-scale React applications serving 50K+ monthly users. Improved page load speed by 35% through code splitting and lazy loading. Collaborated with UX teams to redesign core dashboards, increasing user engagement by 28%. Mentored 3 junior developers and enforced best practices for reusable component architecture.",
    },
    {
      role: "Frontend Developer",
      company: "XYZ Solutions",
      duration: "Jun 2020 – Dec 2021",
      desc:
        "Built responsive and cross-browser compatible web interfaces using React and modern CSS. Reduced UI defects by 40% by introducing component testing with Jest. Integrated REST APIs and improved data fetching efficiency. Worked closely with backend teams in an agile sprint environment.",
    },
  ],

  projects: [
    {
      title: "Enterprise E-Commerce Platform",
      desc:
        "Designed and developed a scalable full-stack e-commerce application using React, Django REST Framework, and MySQL. Implemented secure authentication, product search, cart management, and Stripe payment integration. Optimized performance to handle high concurrent traffic.",
    },
    {
      title: "Real-Time Task Management System",
      desc:
        "Built a collaborative productivity platform with drag-and-drop Kanban boards using React and Firebase. Implemented real-time updates, role-based access control, and notification system to improve team workflow efficiency.",
    },
 
  ],

  education: [
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "XYZ University",
      year: "2016 – 2020",
    },
    {
      degree: "Intermediate (MPC)",
      institution: "Sri Chaitanya Junior College",
      year: "2014 – 2016",
    },
    {
      degree: "10th standard",
      institution: "Sri Chaitanya Junior College",
      year: "2013 – 2014",
    },
  ],

  certifications: [
    { name: "AWS Certified Cloud Practitioner" },
    { name: "Google Associate Cloud Engineer (Training)" },
    { name: "Responsive Web Design Certification – freeCodeCamp" },
  ],
},
  modern: {
  common: {
    name: "Mariana Anderson",
    title: "Marketing Manager",
    summary:
  "Results-driven Marketing Manager with 5+ years of experience leading high-impact digital marketing initiatives and brand growth strategies. Proven track record of increasing customer engagement, optimizing campaign performance, and driving revenue through data-driven decision making. Adept at managing cross-functional teams, executing multi-channel campaigns, and leveraging analytics tools to identify growth opportunities. ",

    photo: "",

    contact: {
      email: "hello@reallygreatsite.com",
      phone: "123-456-xxxx",
      linkedin: "linkedin.com/in/mariana",
      address: "Any City, Any Country",
    },

    skills: ["UI/UX", "Visual Design", "Wireframes", "Storyboards"],
    languages: ["English", "Spanish"],
    tools: ["Figma", "VS Code", "Git"],
  },

  experience: [
  {
    role: "Marketing Manager",
    company: "Ginyard International",
    duration: "2022 – Present",
    location: "New York, USA",
    desc:
      "Spearheaded end-to-end marketing strategies across digital, social media, and paid advertising channels. Led a high-performing team to execute data-driven campaigns that significantly improved brand visibility, customer acquisition, and conversion rates.",

    highlights: [
      "Boosted website traffic by 42% through SEO and content optimization strategies",
      "Increased lead conversion rate by 28% via targeted marketing funnels",
      "Managed $250K annual advertising budget with improved ROI",
      "Launched 5+ multi-channel campaigns reaching over 1M users",
    ],
  },

 
],

  projects: [
    {
      title: "Brand Campaign",
      desc: "Executed multi-channel brand campaign.",
    },
    {
      title: "Product Campaign",
      desc: "Executed multi-channel brand campaign.",
    },
    {
      title: "Brand Campaign",
      desc: "Executed multi-channel brand campaign.",
    },
    
  ],

  education: [
    {
      degree: "Bachelor of Business Management",
      institution: "Borcelle University",
      year: "2021",
    },
  ],
},
experienced: {
  common: {
    name: "Rahul Sharma",
    title: "Software Engineer",
    email: "rahul.sharma.dev@gmail.com",
    phone: "+91 9876xxxxxx",
    linkedin: "linkedin.com/in/rahul-sharma-dev",
    github: "github.com/rahulsharma-dev",
    portfolio: "rahulsharma.dev",
    location: "Hyderabad, India",
    summary:
      "Full Stack Developer with 3+ years of experience building scalable web applications using React, Node.js, and MongoDB. Experienced in designing responsive UI, developing REST APIs, and optimizing application performance. Passionate about clean code, reusable components, and delivering high-quality user experiences."
  },

  experience: [
    {
      role: "Software Engineer",
      company: "Tech Solutions Pvt Ltd",
      location: "Hyderabad, India",
      duration: "Jan 2023 – Present",
      desc:
        "Developed scalable React-based applications serving 10k+ users. Implemented reusable UI components and optimized performance using lazy loading and code splitting. Collaborated with backend teams to integrate REST APIs and improved application speed by 30%. Participated in code reviews and Agile sprint planning."
    },
  ],

  education: [
    {
      degree: "B.Tech in Computer Science",
      institution: "Jawaharlal Nehru Technological University (JNTU)",
      year: "2017 – 2021",
      cgpa: "8.4 / 10",
      details:
        "Relevant Coursework: Data Structures, Algorithms, Database Management Systems, Operating Systems, Web Development."
    },
    {
      degree: "Intermediate",
      institution: "Sri Chaitanya",
      year: "2015 – 2017",
      cgpa: "8.4 / 10",
      details:
        "Relevant Coursework: Data Structures, Algorithms, Database Management Systems, Operating Systems, Web Development."
    }
    
  ],

  projects: [
    {
      title: "Resume Builder Web Application",
      tech: "React, Node.js, HTML, CSS, jsPDF",
      link: "github.com/rahulsharma/resume-builder",
      desc:
        "Developed a dynamic resume builder with customizable templates, real-time preview, and PDF download functionality. Implemented form-based editing and responsive UI for seamless user experience."
    },
  ],

  skills: [
    "React",
    "JavaScript (ES6+)",
    "Node.js",
    "Express.js",
    "MongoDB",
    "HTML5",
    "CSS3",
    "Git & GitHub",
    "REST APIs",
    "Responsive Web Design"
  ],

  certifications: [
  "AWS Certified Cloud Practitioner",
    "Google Data Analytics Professional Certificate",
    "Meta Front-End Developer Professional Certificate"
  
],

  achievements: [
    "Employee of the Month – Tech Solutions Pvt Ltd (Aug 2023)",
    "Top 5 Finalist – National Level Coding Hackathon (2020)",
    "Successfully delivered 3 major client projects before deadlines."
  ],

  languages: [
    "English (Professional)",
    "Hindi (Fluent)",
    "Telugu (Native)"
  ],

  interests: [
    "Open Source Contributions",
    "Technical Blogging on Web Development",
    "UI/UX Design and Modern Web Interfaces",
    "Learning new JavaScript frameworks"
  ]
},
twosidedexperienced: {
  common: {
    name: "Rahul Sharma",
    title: "Software Engineer",
    email: "rahul.sharma.dev@gmail.com",
    phone: "+91 9876xxxxxx",
    linkedin: "linkedin.com/in/rahul-sharma-dev",
    github: "github.com/rahulsharma-dev",
    portfolio: "rahulsharma.dev",
    location: "Hyderabad, India",
    summary:
      "Full Stack Developer with 3+ years of experience building scalable web applications using React, Node.js, and MongoDB. Experienced in designing responsive UI, developing REST APIs, and optimizing application performance. Passionate about clean code, reusable components, and delivering high-quality user experiences."
  },

  experience: [
    {
      role: "Software Engineer",
      company: "Tech Solutions Pvt Ltd",
      location: "Hyderabad, India",
      duration: "Jan 2023 – Present",
      desc:
        "Developed scalable React-based applications serving 10k+ users. Implemented reusable UI components and optimized performance using lazy loading and code splitting. Collaborated with backend teams to integrate REST APIs and improved application speed by 30%. Participated in code reviews and Agile sprint planning."
    },
  ],

  education: [
    {
      degree: "B.Tech in Computer Science",
      institution: "Jawaharlal Nehru Technological University (JNTU)",
      year: "2017 – 2021",
      cgpa: "8.4 / 10",
      details:
        "Relevant Coursework: Data Structures, Algorithms, Database Management Systems, Operating Systems, Web Development."
    },
    {
      degree: "Intermediate",
      institution: "Sri Chaitanya",
      year: "2015 – 2017",
      cgpa: "8.4 / 10",
      details:
        "Relevant Coursework: Data Structures, Algorithms, Database Management Systems, Operating Systems, Web Development."
    }
  ],

  projects: [
  {
    title: "Resume Builder Web Application",
    tech: "React, Node.js, HTML, CSS, jsPDF",
    link: "github.com/rahulsharma/resume-builder",
    desc:
      "Developed a dynamic resume builder with customizable templates, real-time preview, and PDF download functionality. Implemented form-based editing and responsive UI for seamless user experience."
  },
  {
    title: "E-Commerce Dashboard System",
    tech: "React, Express.js, MongoDB, Chart.js, REST APIs",
    link: "github.com/rahulsharma/ecommerce-dashboard",
    desc:
      "Built a full-stack admin dashboard for e-commerce management with product tracking, sales analytics, inventory monitoring, and customer insights. Integrated REST APIs, implemented secure authentication, and optimized dashboard performance for real-time data visualization."
  }
],

  skills: [
    "React",
    "JavaScript (ES6+)",
    "Node.js",
    "Express.js",
    "MongoDB",
    "HTML5",
    "CSS3",
    "Git & GitHub",
    "REST APIs",
    "Responsive Web Design"
  ],

  certifications: [
  "AWS Certified Cloud Practitioner",
    "Google Data Analytics Professional Certificate",
    "Meta Front-End Developer Professional Certificate"
  
],

  achievements: [
    "Employee of the Month – Tech Solutions Pvt Ltd (Aug 2023)",
    "Top 5 Finalist – National Level Coding Hackathon (2020)",
    "Successfully delivered 3 major client projects before deadlines."
  ],

  languages: [
    "English (Professional)",
    "Hindi (Fluent)",
    "Telugu (Native)"
  ],

  interests: [
    "Open Source Contributions",
    "Technical Blogging on Web Development",
    "UI/UX Design and Modern Web Interfaces",
    "Learning new JavaScript frameworks"
  ]
},
atsexperienced: {
  
  common: {
    name: "Rahul Sharma",
    title: "Software Engineer",
    contact: {
    email: "rahul.sharma.dev@gmail.com",
    phone: "+91 9876xxxxxx",
    linkedin: "linkedin.com/in/rahul-sharma-dev",
    github: "github.com/rahulsharma-dev",
    portfolio: "rahulsharma.dev",
    address: "Hyderabad, India",},
    summary:
      "Full Stack Developer with 3+ years of experience building scalable web applications using React, Node.js, and MongoDB. Experienced in designing responsive UI, developing REST APIs, and optimizing application performance. Passionate about clean code, reusable components, and delivering high-quality user experiences.",

  skills: [
    "React",
    "JavaScript (ES6+)",
    "Node.js",
    "Express.js",
    "MongoDB",
    "HTML5",
    "CSS3",
    "Git & GitHub",
    "REST APIs",
    "Responsive Web Design"
  ],},

  education: [
    {
      degree: "B.Tech in Computer Science",
      institution: "Jawaharlal Nehru Technological University (JNTU)",
      year: "2017 – 2021",
      grade: "8.4 / 10",
      details:
        "Relevant Coursework: Data Structures, Algorithms, Database Management Systems, Operating Systems, Web Development."
    },
    {
      degree: "Intermediate",
      institution: "Sri Chaitanya",
      year: "2015 – 2017",
      grade: "8.4 / 10",
      details:
        "Relevant Coursework: Data Structures, Algorithms, Database Management Systems, Operating Systems, Web Development."
    }
  ],
projects: [
    {
      title: "Resume Builder Web Application",
      technologies: ["React", "HTML5", "CSS3", "JavaScript", "Netlify"],
      link: "github.com/rahulsharma/resume-builder",
      desc:
        "Developed a dynamic resume builder with customizable templates, real-time preview, and PDF download functionality. Implemented form-based editing and responsive UI for seamless user experience."
    },
  ],
  certifications: [
  "AWS Certified Cloud Practitioner",
    "Google Data Analytics Professional Certificate",
    "Meta Front-End Developer Professional Certificate"
  
],
  experience: [
    {
      role: "Software Engineer",
      company: "Tech Solutions Pvt Ltd",
      location: "Hyderabad, India",
      duration: "Jan 2023 – Present",
      desc:
        "Developed scalable React-based applications serving 10k+ users. Implemented reusable UI components and optimized performance using lazy loading and code splitting. Collaborated with backend teams to integrate REST APIs and improved application speed by 30%. Participated in code reviews and Agile sprint planning."
    },
  ],
  achievements: [
    "Employee of the Month – Tech Solutions Pvt Ltd (Aug 2023)",
    "Top 5 Finalist – National Level Coding Hackathon (2020)",
    "Successfully delivered 3 major client projects before deadlines."
  ],

  languages: [
    "English (Professional)",
    "Hindi (Fluent)",
    "Telugu (Native)"
  ],

  interests: [
    "Open Source Contributions",
    "Technical Blogging on Web Development",
    "UI/UX Design and Modern Web Interfaces",
    "Learning new JavaScript frameworks"
  ]
},
  atsfresher: {
  common: {
    name: "Alice Smith",
    title: "Front-End Developer ",
    contact: {
      email: "alice.smith983njnhhh@email.com",
      phone: "+1 (111) 222-xxxx",
      linkedin: "linkedin.com/in/alicesmith",
      github: "github.com/alicesmith",
      portfolio: "www.alicesmith.dev",
    address: "123 Main Street, New York, NY, USA",
    },

    skills: [
      "HTML5", "CSS3", "JavaScript (ES6+)", "React.js",
      "Redux", "Bootstrap", "Tailwind CSS"
    ],

    summary:
      "Motivated and detail-oriented Computer Science graduate with a strong foundation in front-end web development and modern JavaScript frameworks. Experienced in building responsive and user-friendly web applications using React, HTML5, CSS3, and REST APIs. ",

    photo: "",
  },

  education: [
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "ABC University",
      year: "2020 – 2024",
      grade: "CGPA: 8.5 / 10",
      coursework: [
        "Data Structures & Algorithms",
        "Database Management Systems",
        "Operating Systems",
        "Computer Networks",
        "Software Engineering",
        "Object-Oriented Programming",
        "Web Technologies",
        "Artificial Intelligence Fundamentals"
      ]
    }
  ],

  projects: [
    {
      title: "Personal Portfolio Website",
      desc:
        "Designed and developed a fully responsive personal portfolio website to showcase projects, technical skills, and achievements. Implemented reusable React components, responsive layouts, and smooth navigation to improve user experience. Deployed the project using Netlify with continuous integration from GitHub.",
      link: "https://alicesmith.dev",
      technologies: ["React", "HTML5", "CSS3", "JavaScript", "Netlify"]
    },
  ],

  certifications: [
    {
      title: "Front-End Web Development Specialization",
      issuer: "Coursera",
      year: "2023",
      details:
        "Covered modern front-end development including HTML5, CSS3, JavaScript, responsive design, and accessibility best practices."
    },
    {
      title: "JavaScript Algorithms and Data Structures",
      issuer: "freeCodeCamp",
      year: "2022",
      details:
        "Completed 300+ coding challenges covering algorithms, recursion, data structures, and problem solving."
    },
    {
      title: "React Developer Certification",
      issuer: "Meta / Coursera",
      year: "2023",
      details:
        "Learned component architecture, hooks, state management, and building scalable React applications."
    }
  ],

  internships: [
    {
      company: "XYZ Tech Solutions",
      role: "Web Development Intern",
      duration: "June 2023 – August 2023",
      desc:
        "Worked with the front-end team to develop responsive UI components for a company dashboard application. Implemented reusable components using React and improved page load performance by optimizing CSS and JavaScript assets. Collaborated with designers and backend developers using Agile development practices."
    }
  ],

  achievements: [
    "Secured 2nd place among 120+ participants in ABC University Hackathon 2022 for developing a collaborative productivity tool.",
    "Awarded Dean's List recognition for academic excellence in 2021 and 2022.",
    
  ],

  hobbies: [
    "Reading technology blogs and staying updated with new web development trends",
    "Playing chess and solving logic puzzles",
  ],

  languages: [
    "English (Fluent)",
    "Spanish (Intermediate)"
  ],

  extraCurriculars: [
    "Active member of the University Coding Club where I participated in weekly coding contests and collaborative project development.",
    "Volunteered as a mentor at a local coding bootcamp helping beginners learn HTML, CSS, and JavaScript fundamentals.",
    "Organized technical workshops and seminars related to web development and open-source contribution."
  ]
},
  headinghighlightfresher: {
  common: {
    name: "Alice Smith",
    title: "Front-End Developer ",
    contact: {
      email: "alice.smith983njnhhh@email.com",
      phone: "+1 (111) 222-xxxx",
      linkedin: "linkedin.com/in/alicesmith",
      github: "github.com/alicesmith",
      portfolio: "www.alicesmith.dev",
    address: "123 Main Street, New York, NY, USA",
    },

    skills: [
      "HTML5", "CSS3", "JavaScript (ES6+)", "React.js",
      "Redux", "Bootstrap", "Tailwind CSS"
    ],

    summary:
      "Motivated and detail-oriented Computer Science graduate with a strong foundation in front-end web development and modern JavaScript frameworks. Experienced in building responsive and user-friendly web applications using React, HTML5, CSS3, and REST APIs. ",

    photo: "",
  },

  education: [
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "ABC University",
      year: "2020 – 2024",
      grade: "CGPA: 8.5 / 10",
      coursework: [
        "Data Structures & Algorithms",
        "Database Management Systems",
        "Operating Systems",
        "Computer Networks",
        "Software Engineering",
        "Object-Oriented Programming",
        "Web Technologies",
        "Artificial Intelligence Fundamentals"
      ]
    }
  ],

  projects: [
    {
      title: "Personal Portfolio Website",
      desc:
        "Designed and developed a fully responsive personal portfolio website to showcase projects, technical skills, and achievements. Implemented reusable React components, responsive layouts, and smooth navigation to improve user experience. Deployed the project using Netlify with continuous integration from GitHub.",
      link: "https://alicesmith.dev",
      technologies: ["React", "HTML5", "CSS3", "JavaScript", "Netlify"]
    },
  ],

  certifications: [
    {
      title: "Front-End Web Development Specialization",
      issuer: "Coursera",
      year: "2023",
      details:
        "Covered modern front-end development including HTML5, CSS3, JavaScript, responsive design, and accessibility best practices."
    },
    {
      title: "JavaScript Algorithms and Data Structures",
      issuer: "freeCodeCamp",
      year: "2022",
      details:
        "Completed 300+ coding challenges covering algorithms, recursion, data structures, and problem solving."
    },
    {
      title: "React Developer Certification",
      issuer: "Meta / Coursera",
      year: "2023",
      details:
        "Learned component architecture, hooks, state management, and building scalable React applications."
    }
  ],

  internships: [
    {
      company: "XYZ Tech Solutions",
      role: "Web Development Intern",
      duration: "June 2023 – August 2023",
      desc:
        "Worked with the front-end team to develop responsive UI components for a company dashboard application. Implemented reusable components using React and improved page load performance by optimizing CSS and JavaScript assets. Collaborated with designers and backend developers using Agile development practices."
    }
  ],

  achievements: [
    "Secured 2nd place among 120+ participants in ABC University Hackathon 2022 for developing a collaborative productivity tool.",
    "Awarded Dean's List recognition for academic excellence in 2021 and 2022.",
    
  ],

  hobbies: [
    "Reading technology blogs and staying updated with new web development trends",
    "Playing chess and solving logic puzzles",
  ],

  languages: [
    "English (Fluent)",
    "Spanish (Intermediate)"
  ],

  extraCurriculars: [
    "Active member of the University Coding Club where I participated in weekly coding contests and collaborative project development.",
    "Volunteered as a mentor at a local coding bootcamp helping beginners learn HTML, CSS, and JavaScript fundamentals.",
    "Organized technical workshops and seminars related to web development and open-source contribution."
  ]
},
  fresher: {
  common: {
    name: "Alice Smith",
    title: "Front-End Developer ",
    contact: {
      email: "alice.smith4687983njnhhh@email.com",
      phone: "+1 (111) 222-xxxx",
      linkedin: "linkedin.com/in/alicesmith",
      github: "github.com/alicesmith",
    },
    portfolio: "www.alicesmith.dev",
    address: "123 Main Street, New York, NY, USA",

    skills: [
      "HTML5", "CSS3", "JavaScript (ES6+)", "React.js",
      "Redux", "Bootstrap", "Tailwind CSS"
    ],

    summary:
      "Motivated and detail-oriented Computer Science graduate with a strong foundation in front-end web development and modern JavaScript frameworks. Experienced in building responsive and user-friendly web applications using React, HTML5, CSS3, and REST APIs. ",

    photo: "",
  },

  education: [
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "ABC University",
      year: "2020 – 2024",
      grade: "CGPA: 8.5 / 10",
      coursework: [
        "Data Structures & Algorithms",
        "Database Management Systems",
        "Operating Systems",
        "Computer Networks",
        "Software Engineering",
        "Object-Oriented Programming",
        "Web Technologies",
        "Artificial Intelligence Fundamentals"
      ]
    }
  ],

  projects: [
    {
      title: "Personal Portfolio Website",
      desc:
        "Designed and developed a fully responsive personal portfolio website to showcase projects, technical skills, and achievements. Implemented reusable React components, responsive layouts, and smooth navigation to improve user experience. Deployed the project using Netlify with continuous integration from GitHub.",
      link: "https://alicesmith.dev",
      technologies: ["React", "HTML5", "CSS3", "JavaScript", "Netlify"]
    },
  ],

  certifications: [
    {
      title: "Front-End Web Development Specialization",
      issuer: "Coursera",
      year: "2023",
      details:
        "Covered modern front-end development including HTML5, CSS3, JavaScript, responsive design, and accessibility best practices."
    },
    {
      title: "JavaScript Algorithms and Data Structures",
      issuer: "freeCodeCamp",
      year: "2022",
      details:
        "Completed 300+ coding challenges covering algorithms, recursion, data structures, and problem solving."
    },
    {
      title: "React Developer Certification",
      issuer: "Meta / Coursera",
      year: "2023",
      details:
        "Learned component architecture, hooks, state management, and building scalable React applications."
    }
  ],

  internships: [
    {
      company: "XYZ Tech Solutions",
      role: "Web Development Intern",
      duration: "June 2023 – August 2023",
      desc:
        "Worked with the front-end team to develop responsive UI components for a company dashboard application. Implemented reusable components using React and improved page load performance by optimizing CSS and JavaScript assets. Collaborated with designers and backend developers using Agile development practices."
    }
  ],

  achievements: [
    "Secured 2nd place among 120+ participants in ABC University Hackathon 2022 for developing a collaborative productivity tool.",
    "Awarded Dean's List recognition for academic excellence in 2021 and 2022.",
    
  ],

  hobbies: [
    "Reading technology blogs and staying updated with new web development trends",
    "Playing chess and solving logic puzzles",
  ],

  languages: [
    "English (Fluent)",
    "Spanish (Intermediate)"
  ],

  extraCurriculars: [
    "Active member of the University Coding Club where I participated in weekly coding contests and collaborative project development.",
    "Volunteered as a mentor at a local coding bootcamp helping beginners learn HTML, CSS, and JavaScript fundamentals.",
    "Organized technical workshops and seminars related to web development and open-source contribution."
  ]
},
creative: {
  common: {
    name: "Sophie Lee",
    title: "UI/UX Designer",
    tagline: "Designing intuitive digital experiences",

    photo: "",

    contact: {
      email: "sophie@example.com",
      phone: "(987) 654-xxxx",
      linkedin: "linkedin.com/in/sophielee"
    },

    portfolio: "sophielee.design",
    address: "San Francisco, CA, USA",

    social: {
      behance: "behance.net/sophielee",
      dribbble: "dribbble.com/sophielee",
      github: "github.com/sophielee",
      medium: "medium.com/@sophielee"
    },

    summary:
      "Creative and detail-oriented UI/UX Designer with over 4 years of experience designing user-centered digital products for startups and enterprise companies. Adept at transforming complex requirements into intuitive and visually engaging interfaces. Experienced in conducting user research, usability testing, wireframing, and high-fidelity prototyping. ",

    skills: [
      "Figma",
      "Adobe XD",
      "Sketch",
      "HTML",
      "CSS",
      "React",
      "Illustrator",
      "Photoshop",
      "Wireframing",
      "Prototyping",
      "User Research",
      "Interaction Design",
    ],

    languages: [
      {name:"English", level:"Fluent",},
      {name:"Korean", level:"Native"},
      {name:"Spanish",level: "Intermediate"}
    ],
  },

  experience: [
    
    {
      role: "Junior Designer",
      company: "CreativeStudio",
      duration: "2019-2021",
      desc:
        "Worked on branding, website layouts, and marketing visuals for multiple client projects across e-commerce, fintech, and education sectors. Assisted senior designers in developing interactive prototypes, user flows, and design systems. Designed responsive landing pages and improved conversion rates through improved visual hierarchy and accessibility improvements."
    },
    
  ],

  education: [
    {
      degree: "B.A. Graphic Design",
      institution: "XYZ University",
      year: "2015-2019",
      grade: "GPA: 3.8 / 4.0"
    },
    {
      degree: "UX Design Specialization",
      institution: "California Institute of Arts (Online)",
      year: "2020",
      grade: "Completed with Distinction"
    }
  ],

  projects: [
    {
      title: "Portfolio Redesign",
      desc:
        "Redesigned personal portfolio website focusing on usability, accessibility, and responsive design. Conducted user feedback sessions and improved navigation structure. Built interactive prototypes in Figma and implemented the final website using React and modern CSS techniques.",
      link: "sophielee.design"
    },
    {
      title: "Mobile App UI for E-Commerce Startup",
      desc:
        "Designed complete mobile app UI/UX including onboarding flows, product browsing, checkout experience, and user profile dashboards. Conducted usability testing and iterated designs to reduce checkout friction by 25%."
    },
    {
      title: "Design System for SaaS Dashboard",
      desc:
        "Developed a reusable design system including typography scales, color tokens, and component libraries. Enabled faster design handoff and improved design consistency across multiple product teams."
    },
    {
      title: "Travel Planner App Concept",
      desc:
        "Conceptualized and designed a travel planning mobile application that helps users organize trips, book activities, and manage itineraries. Built high-fidelity prototypes and conducted usability tests with 15 users."
    }
  ],

  certifications: [
    {
      title: "Google UX Design Professional Certificate",
      issuer: "Google / Coursera",
      year: "2022"
    },
    {
      title: "Interaction Design Foundation – UX Fundamentals",
      issuer: "Interaction Design Foundation",
      year: "2021"
    },
    {
      title: "Responsive Web Design Certification",
      issuer: "freeCodeCamp",
      year: "2020"
    },{
    title: "Web Accessibility and Inclusive Design Certification",
    issuer: "World Wide Web Consortium (W3C)",
    year: "2022 "
  }
  ],

  achievements: [
    "Featured designer on Behance UI Gallery 2022",
    "Winner – University Design Competition 2019",
    "Top 10 Finalist – Global UX Challenge 2021",
    "Speaker at Local UX Meetup on Accessibility Design",
    "Recognized as 'Employee of the Quarter' at DesignHub (2022)"
  ],

  hobbies: [
    "Digital Illustration",
    "Photography",
    "Travel Blogging",
    "Design Community Mentoring",
    "Sketching and Visual Storytelling"
  ]
},
  Black_and_Gold: {
  common: {
    name: "Mariana Anderson",
    title: "Marketing Manager",
    summary:
  "Results-driven Marketing Manager with 5+ years of experience leading high-impact digital marketing initiatives and brand growth strategies. Proven track record of increasing customer engagement, optimizing campaign performance, and driving revenue through data-driven decision making. Adept at managing cross-functional teams, executing multi-channel campaigns, and leveraging analytics tools to identify growth opportunities. ",

    photo: "",

    contact: {
      email: "hello@reallygreatsite.com",
      phone: "123-456-xxxx",
      linkedin: "linkedin.com/in/mariana",
      address: "Any City, Any Country",
    },

    skills: ["UI/UX", "Visual Design", "Wireframes", "Storyboards"],
    languages: ["English", "Spanish"],
    tools: ["Figma", "VS Code", "Git"],
  },

  experience: [
  {
    role: "Marketing Manager",
    company: "Ginyard International",
    duration: "2022 – Present",
    location: "New York, USA",
    desc:
      "Spearheaded end-to-end marketing strategies across digital, social media, and paid advertising channels. Led a high-performing team to execute data-driven campaigns that significantly improved brand visibility, customer acquisition, and conversion rates.",

    highlights: [
      "Boosted website traffic by 42% through SEO and content optimization strategies",
      "Increased lead conversion rate by 28% via targeted marketing funnels",
      "Managed $250K annual advertising budget with improved ROI",
      "Launched 5+ multi-channel campaigns reaching over 1M users",
    ],
  },

 
],

  projects: [
    {
      title: "Brand Campaign",
      desc: "Executed multi-channel brand campaign.",
    },
    {
      title: "Product Campaign",
      desc: "Executed multi-channel brand campaign.",
    },
    {
      title: "Brand Campaign",
      desc: "Executed multi-channel brand campaign.",
    },
    
  ],

  education: [
    {
      degree: "Bachelor of Business Management",
      institution: "Borcelle University",
      year: "2021",
    },
  ],
},
premiumfresher: {
  common: {
    name: "Mariana Anderson",
    title: "Marketing Manager",
    summary:
  "Results-driven Marketing Manager with 5+ years of experience leading high-impact digital marketing initiatives and brand growth strategies. Proven track record of increasing customer engagement, optimizing campaign performance, and driving revenue through data-driven decision making. Adept at managing cross-functional teams, executing multi-channel campaigns, and leveraging analytics tools to identify growth opportunities. ",

    photo: "",

    contact: {
      email: "hello@reallygreatsite.com",
      phone: "123-456-xxxx",
      linkedin: "linkedin.com/in/mariana",
      address: "Any City, Any Country",
    },

    skills: ["UI/UX", "Visual Design", "Wireframes", "Storyboards"],
    languages: ["English", "Spanish","Telugu"],
    tools: ["Figma", "VS Code", "Git"],
  },

  experience: [
  {
    role: "Marketing Manager",
    company: "Ginyard International",
    duration: "2022 – Present",
    location: "New York, USA",
    desc:
      "Spearheaded end-to-end marketing strategies across digital, social media, and paid advertising channels. Led a high-performing team to execute data-driven campaigns that significantly improved brand visibility, customer acquisition, and conversion rates.",

    highlights: [
      "Boosted website traffic by 42% through SEO and content optimization strategies",
      "Increased lead conversion rate by 28% via targeted marketing funnels",
      "Managed $250K annual advertising budget with improved ROI",
      "Launched 5+ multi-channel campaigns reaching over 1M users",
    ],
  },

 
],

  projects: [
    {
      title: "Brand Campaign",
      desc: "Executed multi-channel brand campaign.",
    },
    {
      title: "Product Campaign",
      desc: "Executed multi-channel brand campaign.",
    },
    {
      title: "Brand Campaign",
      desc: "Executed multi-channel brand campaign.",
    },
    
  ],

  education: [
    {
      degree: "Bachelor of Business Management",
      institution: "Borcelle University",
      year: "2021",
    },
  ],
},
green_and_yellow: {
  common: {
    name: "THARUN KAMAN",
    title: "Full Stack Web Developer",

    summary:
      "Results-driven Full Stack Developer with 4+ years of experience designing, developing, and deploying scalable web applications using React, Django, and modern JavaScript frameworks. ",

    contact: {
      email: "frce75@gmail.com",
      phone: "+91 6844xxxxxx",
      linkedin: "linkedin.com/in/devad",
      github: "github.com/devad",
    },

    skills: [
      "JavaScript (ES6+)",
      "React.js",
      "Django",
      "Node.js",
      "Express.js",
      "MySQL",
      "MongoDB",
      "HTML5",
      "CSS3",
      "Tailwind CSS",
      "Bootstrap",
    ],
  },

  experience: [
    {
      role: "Senior Frontend Developer",
      company: "ABC Technologies",
      duration: "Jan 2022 – Present",
      desc:
        "Led development of enterprise-scale React applications serving 50K+ monthly users. Improved page load speed by 35% through code splitting and lazy loading. Collaborated with UX teams to redesign core dashboards, increasing user engagement by 28%. Mentored 3 junior developers and enforced best practices for reusable component architecture.",
    },
    {
      role: "Frontend Developer",
      company: "XYZ Solutions",
      duration: "Jun 2020 – Dec 2021",
      desc:
        "Built responsive and cross-browser compatible web interfaces using React and modern CSS. Reduced UI defects by 40% by introducing component testing with Jest. Integrated REST APIs and improved data fetching efficiency. Worked closely with backend teams in an agile sprint environment.",
    },
  ],

  projects: [
    {
      title: "Enterprise E-Commerce Platform",
      desc:
        "Designed and developed a scalable full-stack e-commerce application using React, Django REST Framework, and MySQL. Implemented secure authentication, product search, cart management, and Stripe payment integration. Optimized performance to handle high concurrent traffic.",
    },
    {
      title: "Real-Time Task Management System",
      desc:
        "Built a collaborative productivity platform with drag-and-drop Kanban boards using React and Firebase. Implemented real-time updates, role-based access control, and notification system to improve team workflow efficiency.",
    },
    {
      title: "Portfolio Website",
      desc:
        "Developed a fully responsive personal portfolio showcasing projects and technical skills. Implemented modern UI animations, SEO optimization, and performance tuning for fast load times.",
    },
  ],

  education: [
    {
      degree: "Bachelor of Science in Computer Science",
      institution: "XYZ University",
      year: "2016 – 2020",
    },
    {
      degree: "Intermediate (MPC)",
      institution: "Sri Chaitanya Junior College",
      year: "2014 – 2016",
    },
  ],

  certifications: [
    { name: "AWS Certified Cloud Practitioner" },
    { name: "Meta Front-End Developer Professional Certificate" },
    { name: "Google Associate Cloud Engineer (Training)" },
    { name: "Responsive Web Design Certification – freeCodeCamp" },
    { name: "JavaScript Algorithms and Data Structures – freeCodeCamp" },
  ],
},
internship: {
  common: {
    name: "Arjun Reddy",
    title: "Full Stack Web Development Intern",

    summary:
      "Highly motivated Computer Science undergraduate with a strong foundation in full-stack web development and problem-solving. Skilled in building scalable and responsive web applications using modern technologies like React, Node.js, and REST APIs. Passionate about learning new technologies, contributing to real-world projects, and delivering clean, efficient, and user-friendly solutions. Seeking an internship opportunity to apply technical skills in a professional environment and gain hands-on industry experience.",

    contact: {
      email: "arjunreddy.dev@gmail.com",
      phone: "+91 9123xxxxxx",
      linkedin: "linkedin.com/in/arjunreddy-dev",
      github: "github.com/arjunreddy-dev",
    },

    skills: [
      "HTML5",
      "CSS3",
      "JavaScript (ES6+)",
      "React.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "MySQL",
      "Git & GitHub",
      "REST APIs",
      "Responsive Web Design",
      "Tailwind CSS",
      "Bootstrap",
      "Basic Data Structures & Algorithms",
      "Problem Solving"
    ],
  },

  // 🎓 EDUCATION
  education: [
    {
      degree: "B.Tech in Computer Science and Engineering",
      institution: "KL University, Vijayawada",
      year: "2022 – 2026",
      cgpa: "8.6 / 10",
    },
    {
      degree: "Intermediate (MPC)",
      institution: "Sri Chaitanya Junior College",
      year: "2020 – 2022",
      cgpa: "9.2 / 10",
    }
  ],

  // 💻 PROJECTS
  projects: [
    {
      title: "Full Stack E-Commerce Website",
      desc:
        "Developed a full-stack e-commerce platform with user authentication, product browsing, cart management, and secure checkout functionality. Implemented RESTful APIs and integrated MongoDB for efficient data storage. Optimized UI for responsiveness and improved performance using lazy loading techniques.",
      tech: "React, Node.js, Express.js, MongoDB",
      link: "github.com/arjunreddy-dev/ecommerce"
    },
    {
      title: "Personal Portfolio Website",
      desc:
        "Designed and developed a modern, fully responsive portfolio website to showcase projects and technical skills. Implemented smooth animations, reusable components, and SEO optimization to improve visibility and performance.",
      tech: "React, Tailwind CSS",
      link: "github.com/arjunreddy-dev/portfolio"
    },
    {
      title: "Task Management Application",
      desc:
        "Built a task management web application with CRUD functionality, allowing users to add, update, and delete tasks. Implemented local storage and optimized UI for better user experience.",
      tech: "JavaScript, HTML, CSS",
      link: "github.com/arjunreddy-dev/task-app"
    },
    {
      title: "Weather Forecast App",
      desc:
        "Developed a weather application that fetches real-time weather data from an external API and displays temperature, humidity, and conditions with dynamic UI updates.",
      tech: "JavaScript, REST API",
      link: "github.com/arjunreddy-dev/weather-app"
    }
  ],

  // 🧑‍💼 INTERNSHIPS
  internships: [
    {
      role: "Web Development Intern",
      company: "ABC Tech Solutions",
      duration: "May 2025 – July 2025",
      desc:
        "Worked on developing responsive front-end components using React and Tailwind CSS. Collaborated with backend developers to integrate REST APIs and improve application performance. Participated in daily stand-ups and Agile sprint cycles, contributing to feature development and bug fixing."
    },
    {
      role: "Frontend Intern",
      company: "InnovateX Labs",
      duration: "Dec 2024 – Feb 2025",
      desc:
        "Assisted in designing and implementing UI components for a dashboard application. Improved user experience by optimizing layouts and fixing UI inconsistencies. Gained hands-on experience in version control using Git and collaborative development workflows."
    }
  ],

  // 📜 CERTIFICATIONS
  certifications: [
    {
      name: "Full Stack Web Development Bootcamp",
      issuer: "Udemy"
    },
    {
      name: "JavaScript Algorithms and Data Structures",
      issuer: "freeCodeCamp"
    },
    {
      name: "React Developer Certification",
      issuer: "Coursera / Meta"
    },
    {
      name: "Responsive Web Design Certification",
      issuer: "freeCodeCamp"
    }
  ],

  // 🏆 ACHIEVEMENTS
  achievements: [
    "Solved 500+ problems on LeetCode and HackerRank",
    "Top 10 finalist in National Level Hackathon 2025",
    "Won 1st prize in college coding competition",
    "Consistently maintained CGPA above 8.5",
    "Built and deployed 5+ full-stack projects independently"
  ],

  // 🌐 LANGUAGES
  languages: [
    "English (Fluent)",
    "Telugu (Native)",
    "Hindi (Intermediate)"
  ]
},
careerProfile: {
  common: {
    name: "Rahul Verma",
    title: "Aspiring Technology Professional | Full Stack Developer | Problem Solver",

    summary:
      "Detail-oriented and adaptable professional transitioning into the technology sector with hands-on experience in developing web applications and solving real-world challenges. Strong foundation in analytical thinking, system design, and user-focused development. Proven ability to quickly learn new tools, collaborate effectively, and deliver efficient solutions. Seeking an opportunity to leverage transferable skills and contribute to impactful technology-driven projects.",

    contact: {
      email: "rahul.verma.tech@gmail.com",
      phone: "+91 9876xxxxxx",
      linkedin: "linkedin.com/in/rahul-verma-tech",
      github: "github.com/rahulverma-dev",
    },

    skills: [
      "Analytical Thinking & Problem Solving",
      "Full Stack Web Development",
      "JavaScript (ES6+), React.js",
      "Node.js & Express.js",
      "Database Management (MySQL, MongoDB)",
      "REST API Integration",
      "Responsive UI/UX Design",
      "Debugging & Optimization",
      "Version Control (Git & GitHub)",
      "Agile Workflow & Team Collaboration",
      "Adaptability & Continuous Learning"
    ],
  },

  // 🎓 EDUCATION
  education: [
    {
      degree: "Bachelor of Technology in Computer Science",
      institution: "SRM Institute of Science and Technology",
      year: "2021 – 2025"
    }
  ],

  // 💼 EXPERIENCE
  experience: [
    {
      role: "Technical Project Contributor",
      company: "Self-Driven Projects",
      duration: "2023 – Present",
      desc:
        "Independently designed and developed multiple web applications focusing on real-world problem solving. Strengthened skills in system design, debugging, and delivering scalable solutions while managing end-to-end development cycles."
    },
    {
      role: "Web Development Intern",
      company: "NextGen Softwares",
      duration: "2024",
      desc:
        "Worked on developing responsive interfaces and integrating backend APIs. Improved application usability and collaborated with team members in a fast-paced development environment."
    }
  ],

  // 🚀 PROJECTS
  projects: [
    {
      title: "Online Shopping Platform",
      desc:
        "Developed a full-featured e-commerce application with authentication, product management, and optimized performance, simulating real-world business workflows.",
      tech: "React, Node.js, MongoDB"
    },
    {
      title: "Task & Productivity Manager",
      desc:
        "Built a task tracking system to enhance productivity and organization, demonstrating efficient workflow design and user-centric development.",
      tech: "JavaScript, HTML, CSS"
    },
    {
      title: "Real-Time Data Applications",
      desc:
        "Created applications integrating third-party APIs to display dynamic data, showcasing strong data handling and API integration skills.",
      tech: "JavaScript, REST APIs"
    }
  ],

  // 📜 CERTIFICATIONS
  certifications: [
    {
      name: "Full Stack Web Development",
      issuer: "Udemy"
    },
    {
      name: "JavaScript Algorithms & Data Structures",
      issuer: "freeCodeCamp"
    }
  ],

  // 🏆 ACHIEVEMENTS
  achievements: [
    "Solved 400+ coding problems across multiple platforms",
    "Built and deployed several independent web applications",
    "Recognized for strong problem-solving and debugging skills",
    "Quickly adapts to new tools and technologies"
  ],

  // 🌐 LANGUAGES
  languages: [
    "English (Professional)",
    "Hindi (Native)"
  ]
},
atsprofessional: {
  common: {
    name: "Rahul Verma",
    title: "Aspiring Technology Professional | Full Stack Developer | Problem Solver",

    summary:
      "Detail-oriented and adaptable professional transitioning into the technology sector with hands-on experience in developing web applications and solving real-world challenges. Strong foundation in analytical thinking, system design, and user-focused development. Proven ability to quickly learn new tools, collaborate effectively, and deliver efficient solutions. Seeking an opportunity to leverage transferable skills and contribute to impactful technology-driven projects.",

    contact: {
      email: "rahul.verma.tech@gmail.com",
      phone: "+91 9876xxxxxx",
      linkedin: "linkedin.com/in/rahul-verma-tech",
      github: "github.com/rahulverma-dev",
    },

    skills: [
      "Analytical Thinking & Problem Solving",
      "Full Stack Web Development",
      "JavaScript (ES6+), React.js",
      "Node.js & Express.js",
      "Database Management (MySQL, MongoDB)",
      "REST API Integration",
      "Responsive UI/UX Design",
      "Debugging & Optimization",
      "Version Control (Git & GitHub)",
      "Agile Workflow & Team Collaboration",
      "Adaptability & Continuous Learning"
    ],
  },

  // 🎓 EDUCATION
  education: [
    {
      degree: "Bachelor of Technology in Computer Science",
      institution: "SRM Institute of Science and Technology",
      year: "2021 – 2025"
    },
    {
      degree: "Intermediate",
      institution: "Sri Chaitanya Junior College",
      year: "2019 – 2021"
    }
  ],

  // 💼 EXPERIENCE
  experience: [
    {
      role: "Technical Project Contributor",
      company: "Self-Driven Projects",
      duration: "2023 – Present",
      desc:
        "Independently designed and developed multiple web applications focusing on real-world problem solving. Strengthened skills in system design, debugging, and delivering scalable solutions while managing end-to-end development cycles."
    },
    {
      role: "Web Development Intern",
      company: "NextGen Softwares",
      duration: "2024",
      desc:
        "Worked on developing responsive interfaces and integrating backend APIs. Improved application usability and collaborated with team members in a fast-paced development environment."
    }
  ],

  // 🚀 PROJECTS
  projects: [
    {
      title: "Online Shopping Platform",
      desc:
        "Developed a full-featured e-commerce application with authentication, product management, and optimized performance, simulating real-world business workflows.",
      tech: "React, Node.js, MongoDB"
    },
    {
      title: "Task & Productivity Manager",
      desc:
        "Built a task tracking system to enhance productivity and organization, demonstrating efficient workflow design and user-centric development.",
      tech: "JavaScript, HTML, CSS"
    },
    {
      title: "Real-Time Data Applications",
      desc:
        "Created applications integrating third-party APIs to display dynamic data, showcasing strong data handling and API integration skills.",
      tech: "JavaScript, REST APIs"
    }
  ],

  // 📜 CERTIFICATIONS
  certifications: [
    {
      name: "Full Stack Web Development",
      issuer: "Udemy"
    },
    {
      name: "JavaScript Algorithms & Data Structures",
      issuer: "freeCodeCamp"
    }
  ],

  // 🏆 ACHIEVEMENTS
  achievements: [
    "Solved 400+ coding problems across multiple platforms",
    "Built and deployed several independent web applications",
    "Recognized for strong problem-solving and debugging skills",
    "Quickly adapts to new tools and technologies"
  ],

  // 🌐 LANGUAGES
  languages: [
    "English (Professional)",
    "Hindi (Native)"
  ]
},
headinghighlightprofessional: {
  common: {
    name: "Rahul Verma",
    title: "Aspiring Technology Professional | Full Stack Developer | Problem Solver",

    summary:
      "Detail-oriented and adaptable professional transitioning into the technology sector with hands-on experience in developing web applications and solving real-world challenges. Strong foundation in analytical thinking, system design, and user-focused development. Proven ability to quickly learn new tools, collaborate effectively, and deliver efficient solutions. Seeking an opportunity to leverage transferable skills and contribute to impactful technology-driven projects.",

    contact: {
      email: "rahul.verma.tech@gmail.com",
      phone: "+91 9876xxxxxx",
      linkedin: "linkedin.com/in/rahul-verma-tech",
      github: "github.com/rahulverma-dev",
    },

    skills: [
      "Analytical Thinking & Problem Solving",
      "Full Stack Web Development",
      "JavaScript (ES6+), React.js",
      "Node.js & Express.js",
      "Database Management (MySQL, MongoDB)",
      "REST API Integration",
      "Responsive UI/UX Design",
      "Debugging & Optimization",
      "Version Control (Git & GitHub)",
      "Agile Workflow & Team Collaboration",
      "Adaptability & Continuous Learning"
    ],
  },

  // 🎓 EDUCATION
  education: [
    {
      degree: "Bachelor of Technology in Computer Science",
      institution: "SRM Institute of Science and Technology",
      year: "2021 – 2025"
    },
  ],

  // 💼 EXPERIENCE
  experience: [
    {
      role: "Technical Project Contributor",
      company: "Self-Driven Projects",
      duration: "2023 – Present",
      desc:
        "Independently designed and developed multiple web applications focusing on real-world problem solving. Strengthened skills in system design, debugging, and delivering scalable solutions while managing end-to-end development cycles."
    },
    {
      role: "Web Development Intern",
      company: "NextGen Softwares",
      duration: "2024",
      desc:
        "Worked on developing responsive interfaces and integrating backend APIs. Improved application usability and collaborated with team members in a fast-paced development environment."
    }
  ],

  // 🚀 PROJECTS
  projects: [
    {
      title: "Online Shopping Platform",
      desc:
        "Developed a full-featured e-commerce application with authentication, product management, and optimized performance, simulating real-world business workflows.",
      tech: "React, Node.js, MongoDB"
    },
    {
      title: "Task & Productivity Manager",
      desc:
        "Built a task tracking system to enhance productivity and organization, demonstrating efficient workflow design and user-centric development.",
      tech: "JavaScript, HTML, CSS"
    },
    {
      title: "Real-Time Data Applications",
      desc:
        "Created applications integrating third-party APIs to display dynamic data, showcasing strong data handling and API integration skills.",
      tech: "JavaScript, REST APIs"
    }
  ],

  // 📜 CERTIFICATIONS
  certifications: [
    {
      name: "Full Stack Web Development",
      issuer: "Udemy"
    },
    {
      name: "JavaScript Algorithms & Data Structures",
      issuer: "freeCodeCamp"
    }
  ],

  // 🏆 ACHIEVEMENTS
  achievements: [
    "Solved 400+ coding problems across multiple platforms",
    "Built and deployed several independent web applications",
    "Recognized for strong problem-solving and debugging skills",
    "Quickly adapts to new tools and technologies"
  ],

  // 🌐 LANGUAGES
  languages: [
    "English (Professional)",
    "Hindi (Native)"
  ]
},
simplesinglepage: {
  common: {
    name: "Arjun Rao",
    title: "Software Engineer",

    summary:
      "Innovative Software Engineer with 5+ years of experience building reliable and user-focused web applications using React, Python, Django, and modern web technologies. Experienced in developing scalable solutions, integrating APIs, optimizing application performance, and collaborating with cross-functional teams.",

    contact: {
      email: "arjun.rao@example.com",
      phone: "+91 98765xxxxx",
      linkedin: "linkedin.com/in/arjunrao",
      github: "github.com/arjunrao",
    },

    skills: [
      "JavaScript",
      "React.js",
      "Python",
      "Django",
      "REST APIs",
      "PostgreSQL",
      "MongoDB",
      "HTML5",
      "CSS3",
      "Git",
      "GitHub",
    ],
  },

  experience: [
    {
      role: "Software Engineer",
      company: "TechNova Solutions",
      duration: "Mar 2022 – Present",
      desc:
        "Developed and maintained scalable web applications using React and Django. Improved application performance by optimizing API calls, database queries, and reusable frontend components. Integrated third-party services and REST APIs while working closely with product and QA teams to deliver reliable features within sprint timelines.",
    },
    {
      role: "Web Developer",
      company: "CloudBridge Technologies",
      duration: "Jul 2020 – Feb 2022",
      desc:
        "Created responsive web applications using React, JavaScript, HTML, and CSS. Developed reusable UI components, integrated backend APIs, and implemented client-side form validation. Collaborated with designers and backend developers to deliver consistent and user-friendly interfaces.",
    },
  ],

  projects: [
    {
      title: "Online Learning Management System",
      desc:
        "Built a full-stack learning platform using React and Django REST Framework. Implemented course browsing, video lessons, progress tracking, quizzes, user dashboards, and REST API integration. Designed the application with reusable components and responsive layouts for desktop and mobile devices.",
    },
    {
      title: "Smart Inventory Management App",
      desc:
        "Developed an inventory management application for tracking products, stock levels, suppliers, and transactions. Implemented React-based dashboards, Django APIs, PostgreSQL database integration, search functionality, and automated stock-status updates.",
    },
    {
      title: "Personal Finance Dashboard",
      desc:
        "Created a responsive finance dashboard that allows users to organize income, expenses, savings goals, and monthly budgets. Added interactive charts, category-based expense tracking, filtering options, and a clean dashboard interface using modern JavaScript and CSS.",
    },
  ],

  education: [
    {
      degree: "Bachelor of Technology in Information Technology",
      institution: "Andhra Institute of Technology",
      year: "2015 – 2019",
    },
    {
      degree: "Intermediate (MPC)",
      institution: "Narayana Junior College",
      year: "2013 – 2015",
    },
  ],

  certifications: [
    { name: "Microsoft Certified: Azure Fundamentals" },
    { name: "Meta Back-End Developer Professional Certificate" },
    { name: "Python Programming Certification – HackerRank" },
    { name: "SQL Advanced Certification – HackerRank" },
    { name: "JavaScript Certification – freeCodeCamp" },
  ],
},
}

export default resumeData;